export default "__VITE_ASSET__BHZl7uzt__"